export const connectionPayload = form => {
  const name = String(form.name || '').trim()
  if (!name || name.length > 60) throw new Error('请填写 1–60 字的连接名称')
  if (!['read_only', 'read_write'].includes(form.mode)) throw new Error('请选择有效的连接模式')
  return { name, mode: form.mode }
}

export const connectionStatus = (connection, now = Date.now()) => {
  if (Number.isFinite(parseTimestamp(connection.revoked_at))) return { label: '已撤销', type: 'info', active: false, toggleable: false }
  const expiresAt = parseTimestamp(connection.expires_at)
  if (connection.expires_at !== null && (!Number.isFinite(expiresAt) || expiresAt <= now)) {
    return { label: '已过期', type: 'warning', active: false, toggleable: false }
  }
  if (typeof connection.enabled !== 'boolean') return { label: '状态未知', type: 'warning', active: false, toggleable: false }
  return connection.enabled
    ? { label: '已开启', type: 'success', active: true, toggleable: true }
    : { label: '已关闭', type: 'info', active: false, toggleable: true }
}

// 后端时间戳按秒返回，同时兼容现有接口的日期字符串。
export const parseTimestamp = value => {
  if (value === null || value === '' || value === undefined) return NaN
  if (/^\d+$/.test(String(value))) return Number(value) > 0 ? Number(value) * 1000 : NaN
  return new Date(String(value).replace(' ', 'T')).getTime()
}

export const formatAccessTime = value => {
  const timestamp = parseTimestamp(value)
  return Number.isFinite(timestamp) ? new Date(timestamp).toLocaleString('zh-CN', { hour12: false }) : '—'
}

export const clientConfig = (endpoint, token = '<请填写本次创建的连接密钥>') => JSON.stringify({
  mcpServers: { ttvan: { type: 'http', url: endpoint, headers: { Authorization: `Bearer ${token}` } } }
}, null, 2)

// 日志只显示服务端摘要，再额外遮盖凭证、长数字和邮件地址；不展示参数/响应原文。
export const safeAccessMessage = value => String(value || '')
  .replace(/Bearer\s+[^\s"',;]+/gi, 'Bearer [已隐藏]')
  .replace(/\bmcp_[A-Za-z0-9_.-]+/gi, '[凭证已隐藏]')
  .replace(/((?:token|secret|password|authorization|密钥|密码)\s*["']?\s*[:=：]\s*["']?)[^\s,"';}]+/gi, '$1[已隐藏]')
  .replace(/\b\d{7,}[\dXx]?\b/g, '[号码已隐藏]')
  .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[邮箱已隐藏]')
  .slice(0, 240)
